<div fxLayout="column" class="dialog">
  <h1 class="title">
    {{ "alert.confirmation" | translate }}
  </h1>
  <div class="full-width">
    <p [innerHTML]="message | translate: paramValue "></p>
  </div>
  <div class="buttons-dialog" fxLayout="row" fxLayoutAlign="end" fxLayoutGap="1%">
    <button class="button-dialog cancel-button" [mat-dialog-close]="{ confirm: false }" mat-flat-button>
      {{ "button.no" | translate }}
    </button>
    <button class="button-dialog confirm-button" [mat-dialog-close]="{ confirm: true }" mat-flat-button>
      {{ "button.yes" | translate }}
    </button>
  </div>
</div>
